import { memo } from "react";
import { Button, DialogFooter, Spinner } from "@repo/ui";

type Props = {
  mode: "create" | "edit";
  isValid: boolean;
  hasChanges: boolean;
  isSubmitting: boolean;
  onClose?: () => void;
};

export const ListDialogFooter = memo<Props>(
  ({ mode, isValid, hasChanges, isSubmitting, onClose }) => {
    return (
      <DialogFooter>
        <Button type="button" variant="secondary" onClick={onClose}>
          Cancel
        </Button>
        <Button type="submit" disabled={!isValid || !hasChanges || isSubmitting}>
          {isSubmitting ? (
            <div className="flex items-center gap-2">
              <Spinner /> Submitting...
            </div>
          ) : mode === "create" ? (
            "Create List"
          ) : (
            "Update List"
          )}
        </Button>
      </DialogFooter>
    );
  }
);

ListDialogFooter.displayName = "ListDialogFooter";
